/** Talk length, uniform from 30 seconds to 10 minutes. Mean 5.25 min. */
export const talkRangeMs = { min: 30_000, max: 10 * 60_000 };

/** Room break, uniform from 1 minute to 10 minutes. Mean 5.5 min. */
export const breakRangeMs = { min: 60_000, max: 10 * 60_000 };

/** (talk mean + break mean). 5.25 + 5.5 = 10.75 minutes. */
export const CYCLE_MEAN_MIN = (0.5 + 10) / 2 + (1 + 10) / 2;

/** Conversations per real hour at the mean cycle: 60 / 10.75. */
export const conversationsPerHour = 60 / CYCLE_MEAN_MIN;

/** Catch-up never looks further back than this. */
export const AWAY_SPAN_CAP_MS = 7 * 24 * 60 * 60 * 1000;

/** Hard cap so a long absence still finishes. */
export const SNIPPET_CAP = 24;

export function rollMs(
  range: { min: number; max: number },
  rand: () => number = Math.random,
): number {
  return Math.round(range.min + rand() * (range.max - range.min));
}

/** Rounded conversation count after the 7-day cap, before the 24-note cap. */
export function uncappedMissedConversationCount(elapsedMs: number): number {
  if (elapsedMs <= 0) return 0;
  const span = Math.min(elapsedMs, AWAY_SPAN_CAP_MS);
  const hoursAway = span / (60 * 60 * 1000);
  return Math.round(hoursAway * conversationsPerHour);
}

/** Notes to request: 7-day cap, round, then at most 24. */
export function missedConversationCount(elapsedMs: number): number {
  return Math.min(SNIPPET_CAP, uncappedMissedConversationCount(elapsedMs));
}
